// Custom code to hide all countries except Canada and US in the currency/country selector
document.addEventListener('DOMContentLoaded', function() {
    // Function to filter countries
    function filterCountries() {
      var countryListItems = document.querySelectorAll('country-selector .custom-select__listbox li');
      
      countryListItems.forEach(function(item) {
        var countryCode = item.getAttribute('data-value');
        if (countryCode !== 'CA' && countryCode !== 'US') {
          item.style.display = 'none';
        }
      });
    }
  
    // Run the filter function once after DOM content is loaded
    setTimeout(filterCountries, 1000); // Adjust the delay as necessary
  
    // Attach a MutationObserver to the dropdown menu to filter countries when content changes
    var listbox = document.querySelector('country-selector .custom-select__listbox');
    if (listbox) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            filterCountries();
          }
        });
      });
  
      observer.observe(listbox, { childList: true, subtree: true });
    }
  
    // Optionally, you can also attach an event listener to the dropdown trigger to ensure it's filtered when clicked
    var dropdown = document.querySelector('.country-selector .custom-select__trigger');
    if (dropdown) {
      dropdown.addEventListener('click', function() {
        setTimeout(filterCountries, 100); // Small delay to ensure items are rendered
      });
    }
  
    /*
     * =======================================
     * US Visitors Auto-Switch to USD (One-Time)
     * =======================================
     * Auto-switches to USD once for US visitors and shows a small toast with undo.
     */
    const usdAutoSwitchKeys = {
      done: 'sanction-usd-auto-switch-done',
      optOut: 'sanction-usd-auto-switch-opt-out',
      toast: 'sanction-usd-auto-switch-toast'
    };
  
    function getLocalizationForm() {
      return document.querySelector('form.localization');
    }
  
    function getCountryInput(form) {
      return form ? form.querySelector('input[name="country_code"]') : null;
    }
  
    function submitCountryCode(countryCode) {
      const form = getLocalizationForm();
      const input = getCountryInput(form);
      if (!form || !input) return false;
      input.value = countryCode;
      form.submit();
      return true;
    }
  
    function canUseStorage(storage) {
      try {
        const testKey = '__storage_test__';
        storage.setItem(testKey, '1');
        storage.removeItem(testKey);
        return true;
      } catch (e) {
        return false;
      }
    }
  
    function getSessionUSFlag() {
      if (!canUseStorage(sessionStorage)) return null;
      const checked = sessionStorage.getItem('us-visitor-checked');
      if (!checked) return null;
      return sessionStorage.getItem('is-us-visitor') === 'true';
    }
  
    function checkBrowserIndicators() {
      try {
        const browserLocale = (navigator.language || navigator.userLanguage || '').toLowerCase();
        const timezone = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
        const isUSLocale = browserLocale === 'en-us' || browserLocale.startsWith('en-us-');
        const canadianTimezones = [
          'toronto', 'vancouver', 'winnipeg', 'edmonton', 'regina', 'halifax',
          'st_johns', 'yellowknife', 'whitehorse', 'dawson', 'montreal', 'ottawa',
          'thunder_bay', 'iqluit'
        ];
        const isUSTimezone = timezone.startsWith('america/') &&
          !canadianTimezones.some(city => timezone.includes(city));
        return isUSTimezone || (isUSLocale && isUSTimezone);
      } catch (e) {
        return false;
      }
    }
  
    function detectUSVisitor() {
      return new Promise((resolve) => {
        const sessionFlag = getSessionUSFlag();
        if (sessionFlag !== null) {
          resolve(sessionFlag);
          return;
        }
  
        let resolved = false;
        const finish = (value) => {
          if (resolved) return;
          resolved = true;
          resolve(value);
        };
  
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        // If IP check doesn't complete in time, default to NOT US.
        // It's better to miss auto-switching for a US visitor than to
        // incorrectly switch a Canadian visitor to USD.
        const timeoutId = setTimeout(() => finish(false), 1500);
  
        fetch('https://ipapi.co/json/', controller ? { signal: controller.signal } : {})
          .then((response) => {
            if (!response.ok) throw new Error('Geo lookup failed');
            return response.json();
          })
          .then((data) => {
            clearTimeout(timeoutId);
            const isUS = data && data.country_code === 'US';
            finish(isUS);
          })
          .catch(() => {
            clearTimeout(timeoutId);
            // If IP check fails, default to NOT US - never guess
            finish(false);
          });
      });
    }
  
    function showCurrencyToast(previousCountryCode) {
      if (document.querySelector('.currency-toast')) return;
  
      const toast = document.createElement('div');
      toast.className = 'currency-toast currency-toast--hidden';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = `
        <div class="currency-toast__content">
          <div class="currency-toast__title">Switched to USD 🇺🇸</div>
          <div class="currency-toast__text">Prices now shown in US dollars.</div>
        </div>
        <div class="currency-toast__actions">
          <button type="button" class="currency-toast__undo">Undo</button>
          <button type="button" class="currency-toast__close" aria-label="Dismiss">✕</button>
        </div>
      `;
  
      const closeToast = () => {
        toast.classList.add('currency-toast--dismissed');
        setTimeout(() => toast.remove(), 300);
      };
  
      const undoButton = toast.querySelector('.currency-toast__undo');
      const closeButton = toast.querySelector('.currency-toast__close');
  
      undoButton.addEventListener('click', () => {
        if (canUseStorage(localStorage)) {
          localStorage.setItem(usdAutoSwitchKeys.optOut, 'true');
          localStorage.removeItem(usdAutoSwitchKeys.toast);
        }
        if (previousCountryCode) {
          submitCountryCode(previousCountryCode);
        }
        closeToast();
      });
  
      closeButton.addEventListener('click', () => {
        if (canUseStorage(localStorage)) {
          localStorage.removeItem(usdAutoSwitchKeys.toast);
        }
        closeToast();
      });
  
      document.body.appendChild(toast);
      requestAnimationFrame(() => toast.classList.remove('currency-toast--hidden'));
  
      setTimeout(() => {
        if (document.body.contains(toast)) {
          closeToast();
        }
      }, 8000);
    }
  
    function maybeShowPostSwitchToast() {
      if (!canUseStorage(localStorage)) return;
      const toastData = localStorage.getItem(usdAutoSwitchKeys.toast);
      if (!toastData) return;
      let data = null;
      try {
        data = JSON.parse(toastData);
      } catch (e) {
        localStorage.removeItem(usdAutoSwitchKeys.toast);
        return;
      }
      localStorage.removeItem(usdAutoSwitchKeys.toast);
      showCurrencyToast(data && data.previousCountryCode);
    }
  
    function maybeAutoSwitchToUSD() {
      if (!canUseStorage(localStorage)) return;
      if (localStorage.getItem(usdAutoSwitchKeys.done) === 'true') return;
      if (localStorage.getItem(usdAutoSwitchKeys.optOut) === 'true') return;
  
      const form = getLocalizationForm();
      const input = getCountryInput(form);
      if (!form || !input) return;
      const currentCountry = input.value;
      if (currentCountry === 'US') {
        detectUSVisitor().then((isUS) => {
          if (!isUS) return;
          if (localStorage.getItem(usdAutoSwitchKeys.done) === 'true') return;
          localStorage.setItem(usdAutoSwitchKeys.done, 'true');
          showCurrencyToast('CA');
        });
        return;
      }
  
      detectUSVisitor().then((isUS) => {
        if (!isUS) return;
        const switched = submitCountryCode('US');
        if (switched) {
          localStorage.setItem(usdAutoSwitchKeys.done, 'true');
          localStorage.setItem(
            usdAutoSwitchKeys.toast,
            JSON.stringify({ previousCountryCode: currentCountry })
          );
        }
      });
    }
  
    maybeShowPostSwitchToast();
    maybeAutoSwitchToUSD();
    
    /*
     * =======================================
     * Free Grip Tooltip Functionality
     * =======================================
     * This code handles the "Free Grip" tooltip on skateboard deck product pages.
     * The tooltip displays "Grip tape only, not applied to board" to clarify
     * that customers receive the grip tape separately, not pre-applied.
     * 
     * - On desktop: Tooltip appears on hover
     * - On mobile: Tooltip toggles on tap/click
     */
    
    // Find all tooltip elements on the page
    const tooltipWrappers = document.querySelectorAll('.tooltip-wrapper');
    
    if (tooltipWrappers.length > 0) {
      tooltipWrappers.forEach(wrapper => {
        // Add touchstart event for mobile devices
        wrapper.addEventListener('touchstart', function(e) {
          if (window.innerWidth <= 767) {
            e.preventDefault();
            this.classList.toggle('mobile-tooltip-active');
            e.stopPropagation();
          }
        });
        
        // Add click event for all devices
        wrapper.addEventListener('click', function(e) {
          if (window.innerWidth <= 767) {
            e.preventDefault();
            this.classList.toggle('mobile-tooltip-active');
            e.stopPropagation();
          }
        });
      });
      
      // Close tooltips when clicking elsewhere on the page
      document.addEventListener('click', function(event) {
        tooltipWrappers.forEach(tooltip => {
          if (!tooltip.contains(event.target)) {
            tooltip.classList.remove('mobile-tooltip-active');
          }
        });
      });
      
      // Close tooltips when touching elsewhere on mobile
      document.addEventListener('touchstart', function(event) {
        tooltipWrappers.forEach(tooltip => {
          if (!tooltip.contains(event.target)) {
            tooltip.classList.remove('mobile-tooltip-active');
          }
        });
      }, { passive: true });
    }
  });
  
  // Remove the parent of "custom-accordion" so that we can add metafield images into the accordion on product pages using "custom liquid" section
  $(".custom-accordion").parent().contents().unwrap();
  
  // Create class for nav items based on inner text titles
  // $('.navigation__link').each(function () {
  //      $(this).addClass($(this).text());
  // });
  $('.navigation__link').each(function () {
    // Get the text, replace spaces with dashes, and strip out non-alphanumeric characters except dashes
    var className = $(this).text()
        .toLowerCase() // Convert to lowercase
        .replace(/[^\w\s-]/g, '') // Remove anything that is not a word character, space, or dash
        .replace(/\s+/g, '-'); // Replace spaces with dashes
    
    // Add the cleaned class name
    $(this).addClass(className);
  });
  
  function addClassesToLabels() {
    if ($('.not-in-quickbuy .label').length) {
      $('.not-in-quickbuy .label').each(function () {
        var className = $(this).text()
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-');
        
        $(this).addClass(className);
      });
    } else {
      setTimeout(addClassesToLabels, 100); // Retry after 100ms if elements aren't present yet
    }
  }
  
  $(document).ready(function () {
    addClassesToLabels();
  });
  
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Function to hide filters
    function hideFilters() {
      // Get all filter groups
      const filterGroups = document.querySelectorAll('.filter-group');
      
      // Get the collection handle from the URL, ignoring any query parameters
      const collectionHandle = window.location.pathname.split('/').pop().split('?')[0];
  
      console.log('Collection Handle:', collectionHandle);
      console.log('Number of filter groups:', filterGroups.length);
  
      // Iterate through all filter groups
      filterGroups.forEach((filterGroup, index) => {
        const filterName = filterGroup.querySelector('.filter-group__heading__text');
  
        if (filterName) {
          const originalFilterName = filterName.textContent.trim();
          console.log(`Filter ${index + 1} Name:`, originalFilterName);
  
          // Check if this is the "Product Type" or "Brand" filter
          if (originalFilterName.toLowerCase() === 'product type' || originalFilterName.toLowerCase() === 'brand') {
            const filterItems = filterGroup.querySelectorAll('.filter-group__item__text');
            
            let matchFound = false;
            filterItems.forEach(item => {
              const itemName = item.textContent.trim();
              const processedItemName = itemName.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
              const processedItemNamePlural = processedItemName + 's';
              
              console.log(`  Item: ${itemName}, Processed: ${processedItemName}, Plural: ${processedItemNamePlural}`);
  
              if (processedItemName === collectionHandle || processedItemNamePlural === collectionHandle) {
                console.log('Match found. Hiding filter group:', originalFilterName);
                filterGroup.style.display = 'none';
                matchFound = true;
                return;
              }
            });
  
            if (!matchFound) {
              console.log(`No match found for ${originalFilterName} filter`);
            }
          }
        }
      });
    }
  
    
  
    // Inject Link to All Brands Under Logos
  // Select the <h2> element inside the .section-logo-list section
  const target = document.querySelector('.section-logo-list h2.hometitle');
  
  // Only proceed if the target element exists
  if (target) {
    // Create the new <a> element
    const link = document.createElement('a');
    link.className = 'small-feature-link brands-all-link';
    link.href = '/pages/brands';
    link.textContent = 'View all';
  
    // Insert the link immediately after the <h2>
    target.insertAdjacentElement('afterend', link);
  } else {
    // Optional: Log something if the section is missing
    console.log('No .section-logo-list h2.hometitle found on this page.');
  }
    
  
    // Run the filter function once after DOM content is loaded
    hideFilters();
  
    // Attach a MutationObserver to the filter container to rerun the filter function when content changes
    const filterContainer = document.querySelector('.collection-filters');
    if (filterContainer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            hideFilters();
          }
        });
      });
      observer.observe(filterContainer, { childList: true, subtree: true });
    }
  
    // Check for URL changes
    let lastUrl = location.href; 
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        hideFilters();
      }
    }).observe(document, {subtree: true, childList: true});
  
    // Optionally, you can also attach an event listener to the filter inputs
    document.addEventListener('change', function(event) {
      if (event.target.closest('.collection-filters')) {
        setTimeout(hideFilters, 100); // Small delay to ensure DOM has updated
      }
    });
  });
  
  
  
  // Replace Question Mark with AI Sparkle Icon on Product Page Collapsable Tabs
  const oldSvg = document.querySelector('.icon--type-question_mark');
  
  if (oldSvg) {
    const newSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    newSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    newSvg.setAttribute('viewBox', '0 0 24 24');
    newSvg.setAttribute('fill', 'none');
    newSvg.setAttribute('stroke', 'currentColor');
    newSvg.setAttribute('stroke-width', '2');
    newSvg.setAttribute('stroke-linecap', 'round');
    newSvg.setAttribute('stroke-linejoin', 'round');
  
    // Copy width and height from the old SVG to the new one
    const width = oldSvg.getAttribute('width') || oldSvg.clientWidth || 16;
    const height = oldSvg.getAttribute('height') || oldSvg.clientHeight || 16;
    newSvg.setAttribute('width', width);
    newSvg.setAttribute('height', height);
  
    // Copy classes from old SVG
    newSvg.setAttribute('class', oldSvg.getAttribute('class'));
  
    // Add the new paths
    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path1.setAttribute('stroke', 'none');
    path1.setAttribute('d', 'M0 0h24v24H0z');
    path1.setAttribute('fill', 'none');
  
    const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path2.setAttribute('d', 'M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z');
  
    newSvg.appendChild(path1);
    newSvg.appendChild(path2);
  
    // Replace the old SVG with the new one
    oldSvg.replaceWith(newSvg);
  }
  
  
  // // Hide Product Type filter on all pages except those in validPaths
  // $(document).ready(function() {
  //   var validPaths = [
  //     "/collections/skate",
  //     "/collections/sale-snowboards",
  //     "/collections/sale-boots",
  //     "/collections/clearance-bindings",
  //     "/collections/mens-outerwear",
  //     "/collections/womens-outerwear",
  //     "/collections/outerwear",
  //     "/collections/back-to-school-sale-2023",
  //     "/collections/nidecker-24",
  //     "/collections/jones",
  //     "/collections/jones-24",
  //     "/collections/gnu-24",
  //     "/collections/nitro-24",
  //     "/collections/volcom-24",
  //     "/collections/volcom",
  //     "/collections/thirtytwo-24",
  //     "/collections/burton",
  //     "/collections/huf",
  //     "/collections/sales",
  //     "/collections/polar",
  //     "/collections/former",
  //     "/collections/yes",
  //     "/collections/yes-25",
  //   ];
  //   var currentPath = window.location.pathname;
  
  //   $('.filter-group').each(function() {
  //     if ($(this).find('.filter-group__heading__text:contains("Product Type")').length) {
  //       if (validPaths.includes(currentPath)) {
  //         $(this).show();
  //       } else {
  //         $(this).hide();
  //       }
  //     }
  //   });
  // });
  
  
  // Make price only bold on the Services page
  document.addEventListener('DOMContentLoaded', function() {
      const elements = document.querySelectorAll('.disclosure__title');
  
      elements.forEach(element => {
          const text = element.innerText;
          const priceMatch = text.match(/\$\d+/); // Find the price part
          if (priceMatch) {
              const price = priceMatch[0];
              const newText = text.replace(price, `<span class="service-price">${price}</span>`);
              element.innerHTML = newText;
          }
      });
  });
  
  
  
  
  
  // Create the Brands page UI
  $(document).ready(function() {
    if($('.brand-list').length > 0) {
      var sortedList = $('.brand-list li').sort(function(a, b) {
        return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
      });
  
      var ul = $('.brand-list').empty();
      var currentChar = null;
      var currentList = null;
  
      sortedList.each(function() {
        var initial = $(this).text().toUpperCase().charAt(0);
        if (!isNaN(initial * 1)) {
          initial = '0-9';
        }
  
        if (initial != currentChar) {
          currentChar = initial;
          var newSection = $('<div id="group-' + currentChar + '" class="section row"><div class="col-md-2 section-heading"><div>' + currentChar + '</div></div></div>');
          var newContainer = $('<div class="col-md-10"><ul class="row"></ul></div>');
          newSection.append(newContainer);
          ul.append(newSection);
          currentList = newContainer.find('ul');
        }
  
        var listItem = $(this);
        listItem.addClass('col-6 col-md-3');
        currentList.append(listItem);
      });
  
      $('#alphabetical-nav a').each(function() {
        var target = $(this.hash);
        if (target.length == 0) {
          $(this).addClass('disabled').click(function(e) { e.preventDefault(); });
        }
      });
  
      $('#alphabetical-nav a').on('click', function(event) {
        event.preventDefault();
        var hash = this.hash;
        var $target = $(hash);
        
        if ($target.length) {
          $('html, body').animate({
            scrollTop: $target.offset().top - 160
          }, {
            duration: 800,
            easing: 'easeInOutCubic',
            complete: function() {
              history.pushState(null, null, hash);
            }
          });
        }
      });
  
      // Check if the device is a touch device
      let isTouchDevice = "ontouchstart" in window || navigator.msMaxTouchPoints;
  
      if (!isTouchDevice) {
        // The new scrolling code here for mouse scroll wheel
        const alphabeticalNav = document.getElementById("alphabetical-nav");
  
        if (alphabeticalNav !== null) {
          // Horizontal scrolling with mouse wheel
          alphabeticalNav.addEventListener("wheel", function (e) {
            e.preventDefault();
            alphabeticalNav.scrollLeft += e.deltaY;
          });
  
          window.addEventListener("scroll", function () {
            var navOffsetTop = alphabeticalNav.offsetTop;
            if (window.scrollY >= navOffsetTop) {
              alphabeticalNav.classList.add("fixed");
            } else {
              alphabeticalNav.classList.remove("fixed");
            }
          });
        }
      }
    }
  
    // Add easing function if not already included
    if (typeof $.easing.easeInOutCubic !== 'function') {
      $.easing.easeInOutCubic = function(x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t + b;
        return c/2*((t-=2)*t*t + 2) + b;
      };
    }
  
    // Brand Search Functionality
    const searchInput = document.getElementById('brandSearchInput');
    const searchClear = document.getElementById('brandSearchClear');
    const brandList = document.getElementById('brandList');
    const noResults = document.getElementById('brandSearchNoResults');
    const alphabeticalNav = document.getElementById('alphabetical-nav');
    
    if (searchInput && brandList) {
      // Wait for the brands to be organized into sections (after the sorting/organizing code runs)
      // Use a function that checks if sections exist, retrying if needed
      function initBrandSearch() {
        const brandItems = Array.from(document.querySelectorAll('.vendor-list-item'));
        const sections = document.querySelectorAll('.section.row');
        
        // If sections exist, initialize search. Otherwise, wait a bit more.
        if (sections.length > 0 || brandItems.length > 0) {
          if (brandItems.length === 0) return;
        
        // Function to get first letter of brand name
        function getBrandFirstChar(brandName) {
          const firstChar = brandName.trim().charAt(0).toUpperCase();
          if (/[0-9]/.test(firstChar)) {
            return '0-9';
          }
          return firstChar;
        }
        
        // Function to filter brands
        function filterBrands(searchTerm) {
          const term = searchTerm.toLowerCase().trim();
          let visibleCount = 0;
          const visibleLetters = new Set();
          
          // Filter brand items
          brandItems.forEach(item => {
            const brandName = item.getAttribute('data-brand-name') || '';
            // Get text from link if it exists, otherwise from item
            const linkElement = item.querySelector('a');
            const brandText = (linkElement ? linkElement.textContent : item.textContent).toLowerCase().trim();
            const matches = brandName.includes(term) || brandText.includes(term);
            
            if (matches) {
              item.classList.remove('hidden');
              item.classList.add('visible');
              visibleCount++;
              // Track which letters have visible brands
              const firstChar = getBrandFirstChar(brandText);
              visibleLetters.add(firstChar);
            } else {
              item.classList.add('hidden');
              item.classList.remove('visible');
            }
          });
          
          // Hide/show entire sections based on whether they have visible brands
          const allSections = document.querySelectorAll('.section.row');
          allSections.forEach(section => {
            const sectionId = section.getAttribute('id');
            if (sectionId) {
              const letter = sectionId.replace('group-', '');
              const sectionItems = section.querySelectorAll('.vendor-list-item');
              const hasVisibleItems = Array.from(sectionItems).some(item => 
                !item.classList.contains('hidden')
              );
              
              if (term.length === 0) {
                // No search - show all sections
                section.style.display = '';
                section.classList.remove('hidden-section');
              } else {
                // Hide sections with no visible items
                if (hasVisibleItems) {
                  section.style.display = '';
                  section.classList.remove('hidden-section');
                } else {
                  section.style.display = 'none';
                  section.classList.add('hidden-section');
                }
              }
            }
          });
          
          // Show/hide no results message
          if (visibleCount === 0 && term.length > 0) {
            if (noResults) {
              noResults.classList.add('visible');
            }
            if (brandList) {
              brandList.style.display = 'none';
            }
          } else {
            if (noResults) {
              noResults.classList.remove('visible');
            }
            if (brandList) {
              brandList.style.display = 'block';
            }
          }
          
          // Update alphabetical navigation
          if (alphabeticalNav) {
            const navLinks = alphabeticalNav.querySelectorAll('a');
            navLinks.forEach(link => {
              const href = link.getAttribute('href');
              if (!href) return;
              
              // Extract letter from href (e.g., #group-A -> A)
              const match = href.match(/#group-(.+)/);
              if (match) {
                const letter = match[1];
                if (term.length === 0) {
                  // No search term - enable all links
                  link.classList.remove('disabled');
                } else {
                  // Check if this letter has visible brands
                  if (visibleLetters.has(letter)) {
                    link.classList.remove('disabled');
                  } else {
                    link.classList.add('disabled');
                  }
                }
              }
            });
          }
        }
        
        // Debounce function for performance
        function debounce(func, wait) {
          let timeout;
          return function executedFunction(...args) {
            const later = () => {
              clearTimeout(timeout);
              func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        }
        
        // Debounced filter function (reduced delay for snappier feel)
        const debouncedFilter = debounce(filterBrands, 100);
        
        // Search input event listener
        searchInput.addEventListener('input', function(e) {
          const term = e.target.value;
          debouncedFilter(term);
          
          // Show/hide clear button
          if (term.length > 0) {
            if (searchClear) {
              searchClear.classList.add('visible');
            }
          } else {
            if (searchClear) {
              searchClear.classList.remove('visible');
            }
          }
        });
        
        // Clear button event listener
        if (searchClear) {
          searchClear.addEventListener('click', function() {
            searchInput.value = '';
            searchClear.classList.remove('visible');
            filterBrands('');
            searchInput.focus();
          });
        }
        
        // Handle keyboard shortcuts
        searchInput.addEventListener('keydown', function(e) {
          // Escape key clears search
          if (e.key === 'Escape') {
            searchInput.value = '';
            if (searchClear) {
              searchClear.classList.remove('visible');
            }
            filterBrands('');
          }
        });
        
        // Initialize - ensure all items are visible on load
        brandItems.forEach(item => {
          item.classList.add('visible');
          item.classList.remove('hidden');
        });
        } else {
          // Sections not ready yet, try again
          setTimeout(initBrandSearch, 50);
        }
      }
      
      // Start initialization
      setTimeout(initBrandSearch, 150);
    }
  
    // Swipe Indicator for Alphabetical Navigation (Mobile Only)
    const swipeIndicator = document.getElementById('swipeIndicator');
    
    if (swipeIndicator && alphabeticalNav && window.innerWidth <= 767) {
      // Position indicator dynamically based on nav position (at bottom, overlapping)
      function positionIndicator() {
        const navRect = alphabeticalNav.getBoundingClientRect();
        const navBottom = navRect.bottom;
        const navLeft = navRect.left;
        const navWidth = navRect.width;
        
        // Position at bottom of nav, slightly overlapping (about 8px up from bottom edge)
        swipeIndicator.style.top = (navBottom - 8) + 'px';
        swipeIndicator.style.left = navLeft + 'px';
        swipeIndicator.style.width = navWidth + 'px';
      }
      
      // Position on load and on scroll
      positionIndicator();
      window.addEventListener('scroll', positionIndicator, { passive: true });
      window.addEventListener('resize', positionIndicator, { passive: true });
      
      const storageKey = 'vendorsPageSwipeIndicatorSeen';
      const hasSeenIndicator = localStorage.getItem(storageKey);
      
      // Only show if user hasn't seen it before
      if (!hasSeenIndicator) {
        let hasSwiped = false;
        let autoFadeTimeout;
        let touchStartX = 0;
        let touchStartY = 0;
        
        // Show indicator after a short delay
        setTimeout(function() {
          swipeIndicator.classList.add('visible');
          
          // Auto-fade after 8 seconds
          autoFadeTimeout = setTimeout(function() {
            hideIndicator();
          }, 8000);
        }, 1000);
        
        // Function to hide indicator
        function hideIndicator() {
          swipeIndicator.classList.add('fading');
          swipeIndicator.classList.remove('visible');
          localStorage.setItem(storageKey, 'true');
          
          // Clean up event listeners
          window.removeEventListener('scroll', positionIndicator);
          window.removeEventListener('resize', positionIndicator);
          
          // Remove element after fade
          setTimeout(function() {
            swipeIndicator.style.display = 'none';
          }, 1000);
        }
        
        // Detect swipe/touch on the nav
        alphabeticalNav.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        
        alphabeticalNav.addEventListener('touchmove', function(e) {
          if (!hasSwiped && touchStartX > 0) {
            const touchEndX = e.touches[0].clientX;
            const touchEndY = e.touches[0].clientY;
            const deltaX = touchStartX - touchEndX;
            const deltaY = Math.abs(touchStartY - touchEndY);
            
            // Detect horizontal swipe (more horizontal than vertical movement)
            if (Math.abs(deltaX) > 30 && Math.abs(deltaX) > deltaY) {
              hasSwiped = true;
              if (autoFadeTimeout) {
                clearTimeout(autoFadeTimeout);
              }
              hideIndicator();
            }
          }
        }, { passive: true });
        
        // Also detect scroll on the nav (which indicates swiping)
        let scrollTimeout;
        alphabeticalNav.addEventListener('scroll', function() {
          if (!hasSwiped) {
            hasSwiped = true;
            if (autoFadeTimeout) {
              clearTimeout(autoFadeTimeout);
            }
            hideIndicator();
          }
        }, { passive: true });
      } else {
        // User has seen it before, hide it and clean up
        swipeIndicator.style.display = 'none';
        window.removeEventListener('scroll', positionIndicator);
        window.removeEventListener('resize', positionIndicator);
      }
    }
  });
  
  
  // **** Hidden for now because breaking on mobile ***
  // // Hide Brand Filter Area on Brand Collection Pages
  // $(document).ready(function() {
  //   hideFilterGroupBasedOnURL();
  
  //   // Listen for changes in the DOM
  //   var observer = new MutationObserver(hideFilterGroupBasedOnURL);
  //   observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
  // });
  
  // function hideFilterGroupBasedOnURL() {
  //   var url = window.location.href;
  //   var lastSegment, vendor;
    
  //   // Check if the URL contains '/collections/vendors?q='
  //   var vendorIndex = url.indexOf('/collections/vendors?q=');
  //   if (vendorIndex !== -1) {
  //     vendor = url.slice(vendorIndex + '/collections/vendors?q='.length).split('&')[0];
  //   }
  
  //   // Check for the last segment of the URL as before
  //   var parts = url.split('?')[0].split('/');
  //   lastSegment = parts.pop() || parts.pop();
  
  //   // Use jQuery to select elements and iterate over them
  //   $('.filter-group__item').each(function() {
  //     var brand = $(this).attr('data-tag');
  //     // Check if brand matches either lastSegment or vendor
  //     if (brand === lastSegment || brand === vendor) {
  //       var ancestorSection = $(this).parents('.filter-group');
  //       if(ancestorSection.length) {
  //         ancestorSection.hide();
  //       }
  //     }
  //   });
  // }
  
  
  
  // This is special code that hides the shipping disclosure on the gift card product page
  document.addEventListener('DOMContentLoaded', function() {
    // Check if the product is a gift card
    const productDiv = document.querySelector('.product');
    
    if (productDiv) {
      // Function to hide the shipping disclosure
      function hideShippingDisclosure() {
        const disclosureTitles = document.querySelectorAll('.disclosure__title');
        disclosureTitles.forEach(title => {
          const withIconBeside = title.querySelector('.with-icon__beside');
          if (withIconBeside && withIconBeside.textContent.trim() === 'Shipping') {
            title.style.display = 'none';
          }
        });
      }
  
      // Check if the product title contains "Gift Card"
      const productTitle = document.querySelector('.product-title');
      if (productTitle && productTitle.textContent.toLowerCase().includes('gift card')) {
        hideShippingDisclosure();
        
        // If it didn't work, try again after a short delay
        setTimeout(hideShippingDisclosure, 500);
  
        // Also, observe for changes in the DOM
        const observer = new MutationObserver(hideShippingDisclosure);
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
  });
  
  
  // Inject Partners Section Under Sanction about section in the footer
  document.addEventListener('DOMContentLoaded', function() {
    // Inject "Proudly Partnered With" section under the Sanction block
    const sanctionColumn = document.querySelector('.section-footer__row__col.section-footer__text-block');
    
    if (sanctionColumn) {
        const partnersSection = document.createElement('div');
        partnersSection.className = 'section-footer__text-block';
        partnersSection.style.marginTop = '30px'; // Add some spacing between sections
        
        partnersSection.innerHTML = `
            <div class="section-footer__title heading-font h6 no-wrap">Proudly Partnered With</div>
            <div class="partners-logos" style="display: flex; align-items: center; gap: 28px; margin-top: 15px;">
               <a href="/pages/mount-st-louis-moonstone"><img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-mslm.png?v=1732728255" alt="Mt. St. Louis Moonstone" style="height: 35px; width: auto;"></a>
               <a href="/pages/park-labs"><img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-park-labs-footer-wide.png?v=1757609541" alt="Park Labs" style="height: 35px; width: auto;"></a>
               <a href="https://www.thesenders.co/" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-senders-footer.png?v=1757609308" alt="Senders" style="height: 35px; width: auto;"></a>
            </div>
        `;
        
        sanctionColumn.appendChild(partnersSection);
    }
  
    // Inject brand logos beside the copyright text
    // const copyrightContainer = document.querySelector('.copyright');
  
    // if (copyrightContainer) {
    //     const brandLogos = document.createElement('div');
    //     brandLogos.className = 'footer-brand-logos';
    //     brandLogos.style.display = 'inline-flex';
    //     brandLogos.style.alignItems = 'center';
    //     brandLogos.style.gap = '10px';
    //     brandLogos.style.marginLeft = '20px'; // Add some space between text and logos
  
    //     brandLogos.innerHTML = `
    //         <img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-mslm.png?v=1732728255" alt="Brand 4" style="height: 24px; width: auto;">
    //     `;
  
    //     copyrightContainer.appendChild(brandLogos);
    // }
  });
  
  
  
  // // Copy to clpboard Secret Sale Coupon
  // let copybtn = document.querySelector(".copybtn");
  // let confirmationMessage = document.querySelector(".confirmation-message");
  
  // function copyIt(){
  //   let copyInput = document.querySelector('#copyvalue');
  //   let copyButtonDiv = document.querySelector('.copy-button');
  //   let copyButtonInput = document.querySelector('.copy-button input');
    
  //   navigator.clipboard.writeText(copyInput.value).then(() => {
  //     copybtn.textContent = "COPIED";
  //     confirmationMessage.classList.add('show');
  //     copyButtonDiv.style.backgroundColor = '#07BC02';
  //     copyButtonDiv.style.borderColor = '#07BC02';
  //     copyButtonInput.style.color = '#fff';
  //   });
  // }
  
  // // Add click event listener to the entire div
  // document.querySelector('.copy-button').addEventListener('click', copyIt);
  
  
  
  // Secret Sale Coupon Reveal and Copy functionality
  document.addEventListener('DOMContentLoaded', function() {
    const blockCorner = document.querySelector('.block.corner');
    if (blockCorner) {
      blockCorner.addEventListener('click', function() {
        const revealCoupon = this.querySelector('.reveal-coupon');
        const card = this.closest('.card');
        const confirmationMessage = card.querySelector('.confirmation-message');
        const fireworks = document.querySelector('.fireworks');
        
        // 1. Change background to green
        this.style.backgroundColor = '#4CAF50';
        
        // 2. Replace SVG with new checkmark
        revealCoupon.querySelector('svg').outerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
            <path d="M5 12l5 5l10 -10"></path>
          </svg>
        `;
        
        // 3 & 4. Hide the corner pseudo-elements by adding a class
        this.classList.add('revealed');
        
        // 5. Change the text content to HORSE26 + copied
        revealCoupon.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
            <path d="M5 12l5 5l10 -10"></path>
          </svg>
          <strong>HORSE26</strong> <span style="font-weight: normal">coupon copied</span>
        `;
  
        // 6. Show confirmation message and expand card
        card.classList.add('expanded');
        confirmationMessage.classList.add('visible');
  
        // 7. Show fireworks
        if (fireworks) {
          fireworks.classList.add('show');
        }
  
        // Copy HORSE26 to clipboard
        navigator.clipboard.writeText('HORSE26').then(() => {
          console.log('Coupon code copied to clipboard');
        }).catch(err => {
          console.error('Failed to copy code: ', err);
        });
      });
    }
  });
  
  
  // Add Attribute to Search for invoking Annex
  // document.querySelectorAll('a.show-search-link').forEach(function(link) {
  //   link.setAttribute('data-annex', '');
  // });
  
  
  
  // // This is special code that accounts for a scenario where we're doing Buy X Get Y in the SAME collection. We only want that little modal in the corner to show up after the first t-shirt is added to cart, not the second and so on. So we need to check the contents of the cart to see if there is already a t-shirt in there. If there is, then we don't show the modal. 
  // // Fetch cart items
  // function fetchCartItems() {
  //     return $.ajax({
  //         type: 'GET',
  //         url: '/cart.js',
  //         dataType: 'json'
  //     });
  // }
  
  // // Fetch product collections
  // function fetchProductCollections(handle) {
  //     return $.ajax({
  //         type: 'GET',
  //         url: '/products/' + handle
  //     }).then(function(data) {
  //         var collectionsString = $(data).find('.product').data('collections');
  //         return collectionsString ? collectionsString.split(',') : [];
  //     });
  // }
  
  // // Get collection handles from the embedded data on the page
  // function getCurrentCollectionHandle() {
  //     var collectionsString = $('.product').data('collections');
  //     if (collectionsString) {
  //         return collectionsString.split(',');
  //     }
  //     return null;
  // }
  
  // // Check if any item is in the desired collection(s)
  // function isItemInDesiredCollection(cart, currentCollectionHandles) {
  //     var productPromises = cart.items.map(function(item) {
  //         return fetchProductCollections(item.handle);
  //     });
  
  //     return Promise.all(productPromises).then(function(allCollections) {
  //         return allCollections.some(function(collections) {
  //             return collections.some(collection => currentCollectionHandles.includes(collection));
  //         });
  //     });
  // }
  
  // // Show the modal
  // function showModal() {
  //     $(document).ready(function() {
  //         $('.add-to-cart').on('click', function() {
  //             $('#buyXgetYmodal').fadeIn();
  //             setTimeout(function() {
  //                 $('#buyXgetYmodal').fadeOut();
  //             }, 2000000); // Adjust if necessary
  //         });
  
  //         $('.close-modal-btn').on('click', function() {
  //             $('#buyXgetYmodal').fadeOut();
  //         });
  //     });
  // }
  
  // // Main execution logic
  // var currentCollectionHandles = getCurrentCollectionHandle();
  
  // if (currentCollectionHandles && currentCollectionHandles.length > 0) {
  //     fetchCartItems().then(function(cart) {
  //         if (cart.items.length === 0) {
  //             showModal();
  //         } else {
  //             isItemInDesiredCollection(cart, currentCollectionHandles).then(function(result) {
  //                 if (!result) {
  //                     showModal();
  //                 }
  //             });
  //         }
  //     });
  // } else {
  //     console.log('Unable to determine collection handle.');
  // }
  
  
  // // For collections that have the free gift modal, this will trigger it to open when Add to Cart is clicked
  //  $(document).ready(function() {
  //     $('.quantity-submit-row__submit .button').on('click', function() {
  //         $('#buyXgetYmodal').fadeIn();
  //         setTimeout(function() {
  //             $('#buyXgetYmodal').fadeOut();
  //         }, 2000000);
  //     });
  
  //     $('.close-modal-btn').on('click', function() {
  //         $('#buyXgetYmodal').fadeOut();
  //     });
  // });
  
  
  
  // $(document).ready(function() {
  //   $('.add-addon-to-cart').click(function(event) {
  //     event.preventDefault();
  //     var id = $(this).data('product-id');
  //     $.ajax({
  //       type: 'POST',
  //       url: '/cart/add.js',
  //       data: {
  //         quantity: 1,
  //         id: id
  //       },
  //       dataType: 'json',
  //       success: function() { 
  //         alert('Add-on product added to cart!');
  //       }
  //     });
  //   });
  // });
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  // This event will be fired whenever the Bundler app is loaded
  document.addEventListener('bundler:bundle_widget_created', function(e) {
  
    // Always show variant dropdown on bundles, even when there is only one option
    // $('.bndlr-select-variant').css( "display", "block" );
  
    // var selectName = $('select').attr('name');
  
    // // add a hidden element with the same name as the select
    // var hidden = $('<input type="hidden" name="'+selectName+'">');
    // hidden.val($('select').val());
    // hidden.insertAfter($('select'));
    
    // $("select option").unwrap().each(function() {
    //     var btn = $('<label class="opt-label"><span class="opt-label__text">'+$(this).text()+'</span></label>');
    //     if($(this).is(':checked')) btn.addClass('on');
    //     $(this).replaceWith(btn);
    // });
    
    // $(document).on('click', '.btn', function() {
    //     $('.opt-label').removeClass('on');
    //     $(this).addClass('on');
    //     $('input[name="'+selectName+'"]').val($(this).text());
    // });
  
  
  
    // function ReplaceSelectWithButtons(selectField) {
    //   // get the basics
    //   var selectValue = selectField.val();
    //   var selectId = selectField.attr('id')
      
    //   // get all options and create buttons
    //   $(selectField).find('option').each(function() {
    //     if ($(this).val()) {
    //       var btn = $('<div data-value="' + $(this).val() + '" data-target="' + selectId  + '" class="selectbtn">' + $(this).text() + '</div>');
    //       if ($(this).val() == selectValue) {
    //         btn.addClass('selected');
    //       }
    //       btn.insertBefore(selectField);
    //     }
    //   });    
    //   // hide the select field
    //   selectField.hide();
  
    //   // map click event to buttons
    //   $(document).on('click', '.selectbtn', function() {
    //     var target = $(this).data('target');
    //     $('.selectbtn[data-target="' + target + '"]').removeClass('selected');
    //     $(this).addClass('selected');
        
    //     // deselect everything, select the selected :)
    //     var selectorAll = '#' + target + ' option';
    //     $(selectorAll).removeAttr('selected');
    //     var selectorSingle = '#' + target + ' option[value="' + $(this).data('value') + '"]';
    //     $(selectorSingle).attr('selected', 'selected');
    //     $(selectorSingle).change();
    //   });
    // }
    
    // // change selects
    // ReplaceSelectWithButtons($('select.id_7279781773491'));
  
  
  });
  
  
  
  
  
  
  // Hide first hr.not-in-quickbuy if specific conditions are met (This to avoid the double hr in the case where there is no inventory wanring, no free shipping and no video review link)
  document.addEventListener('DOMContentLoaded', function() {
    const productForm = document.querySelector('.product-form');
    
    if (productForm) {
      const underPriceDivs = productForm.querySelectorAll('.under-price');
      
      if (underPriceDivs.length === 1) {
        const productInfoBlock = underPriceDivs[0].querySelector('.product-info-block[hidden]');
        
        if (productInfoBlock) {
          const firstHr = productForm.querySelector('hr.not-in-quickbuy');
          if (firstHr) {
            firstHr.style.display = 'none';
          }
        }
      }
    }
  });
  
  
  /* ============================================
   * SMART STICKY FILTERS
   * ============================================
   * When user scrolls and the BOTTOM of .filters reaches 
   * the bottom of the header (.logo-area), collapse and make sticky.
   * Expands when scrolling back up.
   * Only active on desktop (1000px+).
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on collection pages
    if (!document.body.classList.contains('template-collection')) return;
    
    const filtersEl = document.querySelector('.filter-container--side .filters');
    const filtersInner = document.querySelector('.filters__inner');
    const logoArea = document.querySelector('.logo-area');
    
    if (!filtersEl || !filtersInner) return;
    
    let isCollapsed = false;
    let initialFiltersBottom = null; // The original bottom of filters (document-relative)
    let triggerScrollPosition = null; // The scroll position that triggers collapse
    let ticking = false;
    
    // Get the sticky threshold (bottom of header area)
    function getStickyThreshold() {
      // Use the sticky header height CSS variable, plus some padding
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height') || '0');
      return headerHeight + 50; // 50px padding below header
    }
    
    // Calculate trigger point - when filters INNER bottom would reach the sticky threshold
    function captureInitialPosition() {
      if (isCollapsed) return;
      
      // Use filtersInner (the actual content) not filtersEl (the container that stretches full height)
      const filtersInnerRect = filtersInner.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyThreshold = getStickyThreshold();
      
      // Store the absolute document position of the filters INNER BOTTOM
      initialFiltersBottom = scrollTop + filtersInnerRect.bottom;
      
      // Calculate when to trigger: when scrolling causes filters inner bottom to reach sticky threshold
      // filtersInnerRect.bottom (viewport) = initialFiltersBottom - scrollTop
      // We want: initialFiltersBottom - scrollTop <= stickyThreshold
      // So: scrollTop >= initialFiltersBottom - stickyThreshold
      triggerScrollPosition = initialFiltersBottom - stickyThreshold;
      
    }
    
    // Get all filter group headings and their targets
    function getFilterGroups() {
      return filtersInner.querySelectorAll('.filter-group:not(.filter-group--applied):not(.filter-group--availability)');
    }
    
    // Collapse all filter groups with animation
    function collapseFilters() {
      if (isCollapsed) return;
      isCollapsed = true;
      
      const filterGroups = getFilterGroups();
      
      // Add sticky classes and collapse filters first
      filtersEl.classList.add('smart-sticky-active', 'smart-sticky-collapsed');
      
      // Collapse each filter group instantly
      filterGroups.forEach(group => {
        const heading = group.querySelector('.filter-group__heading');
        const target = group.querySelector('.toggle-target');
        
        if (!heading || !target) return;
        
        // Skip if already hidden by user (preserve their choice)
        if (heading.classList.contains('toggle-target-toggler--is-hidden')) {
          heading.setAttribute('data-smart-sticky-was-hidden', 'true');
          return;
        }
        
        // Mark as collapsed by smart sticky
        heading.setAttribute('data-smart-sticky-collapsed', 'true');
        
        // Instant collapse
        target.style.height = '0px';
        target.style.opacity = '0';
        heading.classList.add('toggle-target-toggler--is-hidden');
      });
      
      // Start from high above and invisible
      filtersInner.style.transition = 'none';
      filtersInner.style.opacity = '0';
      filtersInner.style.transform = 'translateY(-150px)';
      
      // Force reflow
      filtersInner.offsetHeight;
      
      // Restore transition and animate down into view
      filtersInner.style.transition = '';
      requestAnimationFrame(() => {
        filtersInner.style.opacity = '1';
        filtersInner.style.transform = 'translateY(0)';
      });
    }
    
    // Expand all filter groups with animation
    function expandFilters() {
      if (!isCollapsed) return;
      isCollapsed = false;
      
      const filterGroups = getFilterGroups();
      
      // Remove sticky classes and expand filters
      filtersEl.classList.remove('smart-sticky-active', 'smart-sticky-collapsed');
      
      // Expand each filter group
      filterGroups.forEach(group => {
        const heading = group.querySelector('.filter-group__heading');
        const target = group.querySelector('.toggle-target');
        const container = target ? target.querySelector('.toggle-target-container') : null;
        
        if (!heading || !target) return;
        
        // Skip if it was already hidden before smart sticky collapsed it
        if (heading.hasAttribute('data-smart-sticky-was-hidden')) {
          heading.removeAttribute('data-smart-sticky-was-hidden');
          return;
        }
        
        // Only expand if we collapsed it (still has the attribute)
        if (!heading.hasAttribute('data-smart-sticky-collapsed')) return;
        heading.removeAttribute('data-smart-sticky-collapsed');
        
        // Get target height
        const targetHeight = container ? container.scrollHeight : target.scrollHeight;
        
        // Set to expanded
        target.style.height = targetHeight + 'px';
        target.style.opacity = '1';
        heading.classList.remove('toggle-target-toggler--is-hidden');
        
        // Clean up inline styles after animation
        setTimeout(() => {
          target.style.height = '';
          target.style.opacity = '';
        }, 600);
      });
      
      // Start from high above and invisible
      filtersInner.style.transition = 'none';
      filtersInner.style.opacity = '0';
      filtersInner.style.transform = 'translateY(-150px)';
      
      // Force reflow
      filtersInner.offsetHeight;
      
      // Restore transition and animate down into view
      filtersInner.style.transition = '';
      requestAnimationFrame(() => {
        filtersInner.style.opacity = '1';
        filtersInner.style.transform = 'translateY(0)';
      });
      
      // Recapture position after expansion settles
      setTimeout(captureInitialPosition, 600);
    }
    
    // Handle manual clicks on filter headings while in sticky mode
    // This allows users to expand individual filters even when collapsed
    function setupManualToggleHandlers() {
      // Use capture phase to run BEFORE the theme's handler
      filtersInner.addEventListener('click', function(e) {
        const heading = e.target.closest('.filter-group__heading');
        if (!heading || !isCollapsed) return;
        
        // If user clicks a heading that we collapsed, we need to manually expand it
        if (heading.hasAttribute('data-smart-sticky-collapsed')) {
          // Prevent the theme's toggle from running (it would get confused)
          e.stopPropagation();
          e.preventDefault();
          
          // Remove our collapse marker
          heading.removeAttribute('data-smart-sticky-collapsed');
          
          // Get the target element
          const target = heading.nextElementSibling;
          if (!target || !target.classList.contains('toggle-target')) return;
          
          const container = target.querySelector('.toggle-target-container');
          const targetHeight = container ? container.scrollHeight : target.scrollHeight;
          
          // Remove the hidden class from heading
          heading.classList.remove('toggle-target-toggler--is-hidden');
          
          // Animate open
          target.style.height = '0px';
          target.style.opacity = '0';
          
          requestAnimationFrame(() => {
            target.style.transition = 'height 0.35s ease, opacity 0.25s ease';
            target.style.height = targetHeight + 'px';
            target.style.opacity = '1';
            
            // Clean up after animation
            setTimeout(() => {
              target.style.height = '';
              target.style.opacity = '';
              target.style.transition = '';
            }, 350);
          });
        }
      }, true); // true = capture phase
    }
    
    // Handle scroll
    function onScroll() {
      if (window.innerWidth < 1000) return;
      if (triggerScrollPosition === null) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (!isCollapsed) {
        // Collapse when we've scrolled past the trigger point
        if (scrollTop >= triggerScrollPosition) {
          collapseFilters();
        }
      } else {
        // Expand when scrolling back up past the trigger point (with buffer)
        if (scrollTop < triggerScrollPosition - 100) {
          expandFilters();
        }
      }
    }
    
    // Throttled scroll handler
    function handleScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    // Initialize
    // Wait a bit for the page to fully render and all filters to load
    setTimeout(() => {
      // Only initialize if we're on desktop
      if (window.innerWidth < 1000) return;
      
      captureInitialPosition();
      setupManualToggleHandlers();
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      // Watch for filter area height changes (when user opens/closes filters)
      // This recalculates the trigger position so it stays accurate
      if (typeof ResizeObserver !== 'undefined') {
        let resizeDebounce;
        const resizeObserver = new ResizeObserver(() => {
          // Don't recalculate while collapsed (we control the height then)
          if (isCollapsed) return;
          
          // Debounce to avoid excessive recalculations
          clearTimeout(resizeDebounce);
          resizeDebounce = setTimeout(() => {
            captureInitialPosition();
          }, 100);
        });
        resizeObserver.observe(filtersInner);
      }
      
      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth < 1000 && isCollapsed) {
            // Force expand on mobile
            filtersEl.classList.remove('smart-sticky-active', 'smart-sticky-collapsed');
            isCollapsed = false;
          } else if (window.innerWidth >= 1000) {
            captureInitialPosition();
          }
        }, 150);
      }, { passive: true });
      
      // Initial check in case page loaded scrolled
      onScroll();
    }, 500);
  });
  
  
  /* ============================================
   * FOOTWEAR SIZE FILTER COLUMN INJECTION
   * ============================================
   * Injects a "By Size" column with a grid of size links
   * into the Footwear navigation dropdown, appearing between
   * the "All Shoes" and "More" columns.
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Configuration: sizes to display in the grid
    const shoesSizes = [
      '4', '4.5', '5',
      '5.5', '6', '6.5',
      '7', '7.5', '8',
      '8.5', '9', '9.5',
      '10', '10.5', '11',
      '11.5', '12', '13',
      '14', '4.5/W6', '5.5/W7',
      '5/W6.5', '6.5/W8', '6/W7.5'
    ];
    
    // Base URL for size filter links
    const baseUrl = '/collections/shoes?filter.v.availability=1&filter.v.option.size=';
    const sortParam = '&sort_by=created-descending';
    
    function injectSizeColumn() {
      // Find the Footwear navigation item (both desktop and mobile)
      const footwearLinks = document.querySelectorAll('.navigation__link');
      
      footwearLinks.forEach(function(link) {
        const linkText = link.textContent.trim().toLowerCase();
        
        // Check if this is the Footwear link
        if (linkText === 'footwear') {
          const navItem = link.closest('.navigation__item');
          if (!navItem) return;
          
          // Find the tier-2 container and columns list
          const tier2Container = navItem.querySelector('.navigation__tier-2-container');
          if (!tier2Container) return;
          
          const columnsList = tier2Container.querySelector('.navigation__tier-2.navigation__columns');
          if (!columnsList) return;
          
          // Check if we've already injected the size column
          if (columnsList.querySelector('.navigation__column--by-size')) return;
          
          // Check if this is mobile navigation
          const isMobile = navItem.closest('.mobile-navigation-drawer') !== null;
          
          // Find the "MORE" column to insert before it
          const columns = columnsList.querySelectorAll('.navigation__column');
          let moreColumn = null;
          let allShoesColumn = null;
          
          columns.forEach(function(col) {
            const titleLink = col.querySelector('.navigation__column-title, .navigation__link');
            if (titleLink) {
              const titleText = titleLink.textContent.trim().toLowerCase();
              if (titleText === 'more') {
                moreColumn = col;
              }
              if (titleText === 'all shoes') {
                allShoesColumn = col;
              }
            }
          });
          
          // Create the size column
          const sizeColumn = document.createElement('li');
          
          if (isMobile) {
            // Mobile: Create a collapsible structure matching the theme exactly
            sizeColumn.className = 'navigation__item navigation__item--with-children navigation__column navigation__column--by-size';
            
            // Create the column title link (same structure as theme)
            const titleLink = document.createElement('a');
            titleLink.href = '/collections/shoes';
            titleLink.className = 'navigation__link navigation__column-title';
            titleLink.setAttribute('aria-haspopup', 'true');
            titleLink.setAttribute('aria-expanded', 'false');
            titleLink.textContent = 'By Size';
            
            // Create the toggle button (exact theme structure)
            const toggleBtn = document.createElement('a');
            toggleBtn.className = 'navigation__children-toggle';
            toggleBtn.href = '#';
            toggleBtn.setAttribute('aria-label', 'Show links');
            // Use exact same SVG as theme's icon-toggle-menu.liquid
            toggleBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation"><path d="m6 9 6 6 6-6"/></svg>';
            
            // Create the collapsible container (tier-3 style)
            const tier3Container = document.createElement('div');
            tier3Container.className = 'navigation__tier-3-container navigation__child-tier';
            
            // Create the size grid inside
            const sizeGrid = document.createElement('div');
            sizeGrid.className = 'nav-size-grid';
            
            // Create size links
            shoesSizes.forEach(function(size) {
              const sizeLink = document.createElement('a');
              sizeLink.href = baseUrl + encodeURIComponent(size) + sortParam;
              sizeLink.className = 'nav-size-grid__item';
              sizeLink.textContent = size;
              sizeGrid.appendChild(sizeLink);
            });
            
            tier3Container.appendChild(sizeGrid);
            
            // Assemble in same order as theme
            sizeColumn.appendChild(titleLink);
            sizeColumn.appendChild(toggleBtn);
            sizeColumn.appendChild(tier3Container);
            
            // Add toggle functionality (matching theme behavior)
            toggleBtn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              const isOpen = sizeColumn.classList.contains('navigation__item--open');
              
              if (isOpen) {
                sizeColumn.classList.remove('navigation__item--open');
                titleLink.setAttribute('aria-expanded', 'false');
              } else {
                sizeColumn.classList.add('navigation__item--open');
                titleLink.setAttribute('aria-expanded', 'true');
              }
            });
            
          } else {
            // Desktop: Simple column layout
            sizeColumn.className = 'navigation__item navigation__column navigation__column--by-size';
            
            // Create the column title
            const titleLink = document.createElement('a');
            titleLink.href = '/collections/shoes';
            titleLink.className = 'navigation__link navigation__column-title';
            titleLink.textContent = 'By Size';
            
            // Create the size grid container
            const sizeGrid = document.createElement('div');
            sizeGrid.className = 'nav-size-grid';
            
            // Create size links
            shoesSizes.forEach(function(size) {
              const sizeLink = document.createElement('a');
              sizeLink.href = baseUrl + encodeURIComponent(size) + sortParam;
              sizeLink.className = 'nav-size-grid__item';
              sizeLink.textContent = size;
              sizeGrid.appendChild(sizeLink);
            });
            
            // Assemble the column
            sizeColumn.appendChild(titleLink);
            sizeColumn.appendChild(sizeGrid);
          }
          
          // Insert the column (after ALL SHOES, before MORE, or at the end)
          if (moreColumn) {
            columnsList.insertBefore(sizeColumn, moreColumn);
          } else if (allShoesColumn && allShoesColumn.nextSibling) {
            columnsList.insertBefore(sizeColumn, allShoesColumn.nextSibling);
          } else {
            // Insert before any promotion columns
            const promoColumn = columnsList.querySelector('.navigation__column--promotion');
            if (promoColumn) {
              columnsList.insertBefore(sizeColumn, promoColumn);
            } else {
              columnsList.appendChild(sizeColumn);
            }
          }
          
          // Update column count class on the parent
          updateColumnCount(columnsList);
        }
      });
    }
    
    function updateColumnCount(columnsList) {
      // Count non-promotion columns
      const nonPromoColumns = columnsList.querySelectorAll('.navigation__column:not(.navigation__column--promotion)');
      const totalColumns = columnsList.querySelectorAll('.navigation__column');
      
      // Remove existing count classes
      columnsList.className = columnsList.className.replace(/navigation__columns--count-\d+/g, '');
      columnsList.className = columnsList.className.replace(/navigation__columns--5-cols/g, '');
      columnsList.className = columnsList.className.replace(/navigation__columns--over-5-cols/g, '');
      
      // Add appropriate classes
      columnsList.classList.add('navigation__columns--count-' + totalColumns.length);
      if (nonPromoColumns.length === 5) {
        columnsList.classList.add('navigation__columns--5-cols');
      } else if (nonPromoColumns.length > 5) {
        columnsList.classList.add('navigation__columns--over-5-cols');
      }
    }
    
    // Inject the size grid CSS
    function injectSizeGridStyles() {
      if (document.getElementById('nav-size-grid-styles')) return;
      
      const styles = document.createElement('style');
      styles.id = 'nav-size-grid-styles';
      styles.textContent = `
        /* Nav Size Grid - Footwear Dropdown */
        
        /* Size grid styling */
        .nav-size-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 5px;
          margin-top: 8px;
          width: 200px;
        }
        
        .nav-size-grid__item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 7px 2px;
          border: 1px solid #d5d5d5;
          border-radius: 3px;
          font-size: 11px;
          font-weight: 500;
          color: #444;
          text-decoration: none;
          background: #fff;
          transition: all 0.15s ease;
          white-space: nowrap;
          min-height: 30px;
        }
        
        .nav-size-grid__item:hover {
          border-color: #000;
          background: #000;
          color: #fff;
        }
        
        /* Mobile navigation drawer - By Size column */
        .mobile-navigation-drawer .navigation__column--by-size {
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 100%;
          position: relative;
        }
        
        .mobile-navigation-drawer .navigation__column--by-size > .navigation__link {
          flex: 1 1 0;
          max-width: calc(100% - 60px);
        }
        
        .mobile-navigation-drawer .navigation__column--by-size > .navigation__children-toggle {
          flex: 0 0 auto;
        }
        
        .mobile-navigation-drawer .navigation__column--by-size > .navigation__tier-3-container {
          flex-basis: 100%;
          padding: 0 20px;
          visibility: hidden;
          height: 0;
          opacity: 0;
          overflow: hidden;
        }
        
        .mobile-navigation-drawer .navigation__column--by-size.navigation__item--open > .navigation__tier-3-container {
          visibility: visible;
          height: auto;
          opacity: 1;
          padding: 5px 20px 20px;
        }
        
        .mobile-navigation-drawer .nav-size-grid {
          grid-template-columns: repeat(4, 1fr);
          gap: 8px;
          width: 100%;
          max-width: 100%;
        }
        
        .mobile-navigation-drawer .nav-size-grid__item {
          padding: 12px 6px;
          font-size: 14px;
          min-height: 44px;
          border-radius: 4px;
        }
        
        @media (max-width: 380px) {
          .mobile-navigation-drawer .nav-size-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `;
      
      document.head.appendChild(styles);
    }
    
    // Run injection
    injectSizeGridStyles();
    injectSizeColumn();
    
    // Re-run on DOM changes (for dynamically loaded content)
    const observer = new MutationObserver(function(mutations) {
      let shouldInject = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
              node.classList?.contains('navigation__tier-2-container') ||
              node.querySelector?.('.navigation__tier-2-container')
            )) {
              shouldInject = true;
            }
          });
        }
      });
      if (shouldInject) {
        injectSizeColumn();
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also run after a delay to catch any late-loading content
    setTimeout(injectSizeColumn, 500);
    setTimeout(injectSizeColumn, 1500);
  });
  
  
  // Inject Instagram icon beside "From the 'Gram" heading
  document.addEventListener('DOMContentLoaded', function() {
    function injectInstagramIcon() {
      // Find all headings on the page
      const allHeadings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
      
      allHeadings.forEach(function(heading) {
        // Check if icon already exists to avoid duplicates
        if (heading.querySelector('.instagram-icon-injected')) {
          return;
        }
        
        // Get text content, filtering out any existing SVG elements
        let textContent = '';
        heading.childNodes.forEach(function(node) {
          if (node.nodeType === 3) { // Text node
            textContent += node.textContent;
          }
        });
        
        // Normalize the text - handle different quote types and whitespace
        const normalizedText = textContent.trim().replace(/[''""]/g, "'");
        
        // Check if heading contains "From the" and "Gram" (case insensitive)
        const lowerText = normalizedText.toLowerCase();
        if (lowerText.includes("from the") && lowerText.includes("gram")) {
          console.log('Found "From the Gram" heading, injecting icon...', heading);
          
          // Create Instagram SVG icon using the provided SVG
          const instagramIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          instagramIcon.setAttribute('class', 'instagram-icon-injected icon');
          instagramIcon.setAttribute('width', '24');
          instagramIcon.setAttribute('height', '24');
          instagramIcon.setAttribute('viewBox', '0 0 48 48');
          instagramIcon.setAttribute('aria-hidden', 'true');
          instagramIcon.setAttribute('focusable', 'false');
          instagramIcon.setAttribute('role', 'presentation');
          instagramIcon.style.display = 'inline-block';
          instagramIcon.style.verticalAlign = 'middle';
          instagramIcon.style.marginRight = '12px';
          instagramIcon.style.flexShrink = '0';
          instagramIcon.style.color = '#000';
          instagramIcon.style.position = 'relative';
          instagramIcon.style.top = '-0.075em';
          
          // Add the Instagram path
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M24 0c-6.518 0-7.335.028-9.895.144-2.555.117-4.3.523-5.826 1.116-1.578.613-2.917 1.434-4.25 2.768C2.693 5.362 1.872 6.701 1.26 8.28.667 9.806.26 11.55.144 14.105.028 16.665 0 17.482 0 24s.028 7.335.144 9.895c.117 2.555.523 4.3 1.116 5.826.613 1.578 1.434 2.917 2.768 4.25 1.334 1.335 2.673 2.156 4.251 2.77 1.527.592 3.271.998 5.826 1.115 2.56.116 3.377.144 9.895.144s7.335-.028 9.895-.144c2.555-.117 4.3-.523 5.826-1.116 1.578-.613 2.917-1.434 4.25-2.768 1.335-1.334 2.156-2.673 2.77-4.251.592-1.527.998-3.271 1.115-5.826.116-2.56.144-3.377.144-9.895s-.028-7.335-.144-9.895c-.117-2.555-.523-4.3-1.116-5.826-.613-1.578-1.434-2.917-2.768-4.25-1.334-1.335-2.673-2.156-4.251-2.769-1.527-.593-3.271-1-5.826-1.116C31.335.028 30.518 0 24 0Zm0 4.324c6.408 0 7.167.025 9.698.14 2.34.107 3.61.498 4.457.827 1.12.435 1.92.955 2.759 1.795.84.84 1.36 1.64 1.795 2.76.33.845.72 2.116.827 4.456.115 2.53.14 3.29.14 9.698s-.025 7.167-.14 9.698c-.107 2.34-.498 3.61-.827 4.457-.435 1.12-.955 1.92-1.795 2.759-.84.84-1.64 1.36-2.76 1.795-.845.33-2.116.72-4.456.827-2.53.115-3.29.14-9.698.14-6.409 0-7.168-.025-9.698-.14-2.34-.107-3.61-.498-4.457-.827-1.12-.435-1.92-.955-2.759-1.795-.84-.84-1.36-1.64-1.795-2.76-.33-.845-.72-2.116-.827-4.456-.115-2.53-.14-3.29-.14-9.698s.025-7.167.14-9.698c.107-2.34.498-3.61.827-4.457.435-1.12.955-1.92 1.795-2.759.84-.84 1.64-1.36 2.76-1.795.845-.33 2.116-.72 4.456-.827 2.53-.115 3.29-.14 9.698-.14Zm0 7.352c-6.807 0-12.324 5.517-12.324 12.324 0 6.807 5.517 12.324 12.324 12.324 6.807 0 12.324-5.517 12.324-12.324 0-6.807-5.517-12.324-12.324-12.324ZM24 32a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm15.691-20.811a2.88 2.88 0 1 1-5.76 0 2.88 2.88 0 0 1 5.76 0Z');
          path.setAttribute('fill', 'currentColor');
          path.setAttribute('fill-rule', 'evenodd');
          
          instagramIcon.appendChild(path);
          
          // Insert icon at the beginning (left side) of the heading
          if (heading.firstChild) {
            heading.insertBefore(instagramIcon, heading.firstChild);
          } else {
            heading.appendChild(instagramIcon);
          }
        }
      });
    }
    
    // Run immediately
    injectInstagramIcon();
    
    // Also run after delays in case content loads dynamically
    setTimeout(injectInstagramIcon, 500);
    setTimeout(injectInstagramIcon, 1000);
    setTimeout(injectInstagramIcon, 2000);
    
    // Observe for DOM changes
    const observer = new MutationObserver(function(mutations) {
      injectInstagramIcon();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });


  // ==========================================================================
  // BENTO GRID — Subtle gray fill for interior empty cells
  // ==========================================================================
  window.addEventListener('load', function() {
    var grid = document.querySelector('.template-suffix-brand .product-grid');
    if (!grid || window.innerWidth < 768) return;

    var cols = 4;
    var gridRect = grid.getBoundingClientRect();
    var colWidth = gridRect.width / cols;

    var rowTopSet = {};
    var items = [];

    Array.from(grid.children).forEach(function(el) {
      if (el.classList.contains('bento-filler') || el.offsetHeight === 0) return;
      var rect = el.getBoundingClientRect();
      var top = Math.round(rect.top);
      var bottom = Math.round(rect.bottom);
      rowTopSet[top] = true;
      items.push({ top: top, bottom: bottom, left: rect.left - gridRect.left, right: rect.right - gridRect.left });
    });

    var rowTops = Object.keys(rowTopSet).map(Number).sort(function(a, b) { return a - b; });
    if (rowTops.length === 0) return;

    var occupied = new Set();
    items.forEach(function(item) {
      var startCol = Math.floor(item.left / colWidth);
      var endCol = Math.round(item.right / colWidth);
      for (var ri = 0; ri < rowTops.length; ri++) {
        if (rowTops[ri] >= item.top && rowTops[ri] < item.bottom) {
          for (var c = startCol; c < endCol; c++) {
            occupied.add(ri + ',' + c);
          }
        }
      }
    });

    // Find empty cells that have an occupied cell to their right (interior gaps)
    for (var ri = 0; ri < rowTops.length; ri++) {
      for (var c = 0; c < cols; c++) {
        if (occupied.has(ri + ',' + c)) continue;

        var hasRight = false;
        for (var cr = c + 1; cr < cols; cr++) {
          if (occupied.has(ri + ',' + cr)) { hasRight = true; break; }
        }
        if (!hasRight) continue;

        var filler = document.createElement('div');
        filler.style.gridRow = (ri + 1);
        filler.style.gridColumn = (c + 1);
        filler.className = 'bento-interior-filler';
        filler.setAttribute('aria-hidden', 'true');
        grid.appendChild(filler);
      }
    }

    // Remove bottom border from items in the last row
    var maxBottom = 0;
    items.forEach(function(item) { maxBottom = Math.max(maxBottom, item.bottom); });

    Array.from(grid.children).forEach(function(el) {
      if (el.classList.contains('bento-filler') || el.offsetHeight === 0) return;
      var rect = el.getBoundingClientRect();
      if (Math.round(rect.bottom) === maxBottom) {
        el.style.borderBottom = 'none';
      }
    });
  });
